var map = {
	"./Agent.json": "2227",
	"./AgentMock.json": "dc8c",
	"./DisputableDelay.json": "d5af",
	"./Governor.json": "7f66",
	"./TestToken.json": "8d51",
	"./veGyro.json": "21b2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "be09";